import { GripIcon } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { SortableSectionProps } from './types';

export function SortableSection({ section, children }: SortableSectionProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: section });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={isDragging ? 'opacity-50' : ''}
    >
      <div className="relative">
        <div
          {...attributes}
          {...listeners}
          className="absolute top-5 left-5 text-gray-400 cursor-grab active:cursor-grabbing z-10"
        >
          <GripIcon className="h-4 w-4" />
        </div>
        {children}
      </div>
    </div>
  );
}
